import { cn } from '@massilia/ui'
import { ChevronDown } from 'lucide-react'
import { type ReactNode, useState } from 'react'

interface FilterDrawerProps {
  children: ReactNode
  defaultOpen?: boolean
  onReset?: () => void
  showReset?: boolean
  title: string
}

export function FilterDrawer({
  children,
  defaultOpen = true,
  onReset,
  showReset = false,
  title,
}: FilterDrawerProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="border-b border-gray-200">
      <button
        className="flex w-full items-center justify-between py-3 text-left"
        onClick={() => {
          setIsOpen(!isOpen)
        }}
        type="button"
      >
        <span className="text-sm font-medium text-gray-900">{title}</span>
        <div className="flex items-center gap-2">
          {showReset && onReset && (
            <span
              className="cursor-pointer text-xs text-brand-600 hover:text-brand-800 hover:underline"
              onClick={(e) => {
                e.stopPropagation()
                onReset()
              }}
            >
              Réinitialiser
            </span>
          )}
          <ChevronDown
            className={cn('h-4 w-4 text-gray-500 transition-transform', isOpen && 'rotate-180')}
          />
        </div>
      </button>
      <div
        className={cn(
          'overflow-hidden transition-all duration-200',
          isOpen ? 'max-h-[1500px] pb-4' : 'max-h-0'
        )}
      >
        {children}
      </div>
    </div>
  )
}
